import { EMPTY_STRING, USER_TYPES } from 'common/constants';
import { getResfreshToken } from 'common/utils/auth/refreshToken';
import parseJwt from 'common/utils/auth/parseJWT';

export const getUserType = () => {
  const refreshToken = getResfreshToken();

  if (!refreshToken) {
    return {
      userType: USER_TYPES.none,
      isMapsClient: false,
    };
  }

  const tokenData = parseJwt(refreshToken);
  const userType = (
    tokenData['http://schemas.zgs.loc/e100/identity/claims/clientid'] ||
    EMPTY_STRING
  ).toLowerCase();

  return {
    userType,
    isMapsClient: userType === USER_TYPES.mapsClient,
  };
};

export default getUserType;
